const t = {
  name: "Ethernet",
  dimensions: { width: 40, height: 34 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 34" style="enable-background:new 0 0 40 34;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M17,21h6v2h-6V21z"/>
		<path class="st0" d="M5,20c0,1.7,1.3,3,3,3h3.4l2.2,4.3c0.5,1,1.5,1.7,2.7,1.7h7.5c1.1,0,2.2-0.6,2.7-1.7l2.2-4.3H32
			c1.7,0,3-1.3,3-3V5H5V20z M7,7h5v7h2V7h5v7h2V7h5v7h2V7h5v13c0,0.6-0.5,1-1,1h-4.6l-2.7,5.5c-0.2,0.3-0.5,0.5-0.9,0.5h-7.5
			c-0.4,0-0.7-0.2-0.9-0.5L12.6,21H8c-0.6,0-1-0.4-1-1V7z"/>
		<path class="st0" d="M37,0H3C1.3,0,0,1.4,0,3v28c0,1.7,1.3,3,3,3h34c1.6,0,3-1.3,3-3V3C40,1.4,38.6,0,37,0z M38,31
			c0,0.6-0.5,1-1,1H3c-0.6,0-1-0.4-1-1V3c0-0.6,0.4-1,1-1h34c0.5,0,1,0.4,1,1V31z"/>
	</g>
</g>
</svg>
  `
};
export {
  t as Ethernet
};
